/**
 * LevNutri - Tela de Login
 */

import React, { useState } from 'react';
import { authService, passwordResetService } from '../services/api';
import './Login.css';
import { Ico } from './ui/Ico';

const LOGO_URL = 'https://www.levnutri.com/assets/logo.png';

function Login({ onLogin }) {
  const [email, setEmail]           = useState('');
  const [password, setPassword]     = useState('');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const [logoError, setLogoError]   = useState(false);
  const [esqueci, setEsqueci]       = useState(false);   // modo "esqueci minha senha"
  const [resetMsg, setResetMsg]     = useState('');

  const handleForgot = async (e) => {
    e.preventDefault();
    setError('');
    setResetMsg('');
    setLoading(true);
    try {
      const res = await passwordResetService.forgot(email);
      setResetMsg(res.message || 'Se este e-mail estiver cadastrado, você receberá um link por e-mail.');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao solicitar redefinição');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authService.login(email, password);
      if (response.success) {
        onLogin(response.data);
      } else {
        setError(response.error || 'Erro ao fazer login');
      }
    } catch (err) {
      const msg = err.response?.data?.error || 'Erro ao conectar com o servidor';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            {!logoError ? (
              <img
                src={LOGO_URL}
                alt="LevNutri"
                style={{ height: '72px', objectFit: 'contain' }}
                onError={() => setLogoError(true)}
              />
            ) : (
              <>
                <span className="login-logo-icon"><Ico e="🥗" /></span>
                <h1 className="login-logo-text">LevNutri</h1>
              </>
            )}
          </div>
          <p className="login-subtitle">Sistema de Gestão Nutricional</p>
        </div>

        {error && (
          <div className="login-error">
            <span className="error-icon"><Ico e="⚠" /></span>
            <span>{error}</span>
          </div>
        )}

        {resetMsg && (
          <div style={{ background: '#edf4ee', border: '1px solid #edf4ee', borderRadius: '10px', padding: '0.75rem 1rem', marginBottom: '1rem', fontSize: '0.86rem', color: '#2f5236' }}>
            <Ico e="💬" /> {resetMsg}
          </div>
        )}

        <form onSubmit={esqueci ? handleForgot : handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              disabled={loading}
              autoComplete="email"
            />
          </div>

          {!esqueci && (
            <div className="form-group">
              <label htmlFor="password">Senha</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
                autoComplete="current-password"
              />
            </div>
          )}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? (
              <span className="button-spinner" />
            ) : esqueci ? (
              <span>Enviar link por e-mail</span>
            ) : (
              <>
                <span>Entrar</span>
                <span className="button-arrow">→</span>
              </>
            )}
          </button>
        </form>

        <button
          type="button"
          onClick={() => { setEsqueci(v => !v); setError(''); setResetMsg(''); }}
          style={{ background: 'none', border: 'none', color: '#b8895c', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600, marginTop: '0.9rem', width: '100%' }}
        >
          {esqueci ? '← Voltar para o login' : 'Esqueci minha senha'}
        </button>
      </div>

      <div className="login-credits">
        <p>© {new Date().getFullYear()} LevNutri · Todos os direitos reservados</p>
      </div>
    </div>
  );
}

export default Login;
